export default {
    welcome: 'Welcome to the',
    title: 'You want to reset your password?',
    subtitle: 'Please enter your e-mail address and you will receive an e-mail with a link to reset your password:',
    email: {
        label: 'E-mail',
        error: {
            required: 'Please enter your e-mail address',
            email: 'Please enter a valid e-mail address'
        }
    },
    action: 'Reset password',
    feedback: 'We sent an e-mail to {email}. It contains a link to reset your password.',
    poweredby: 'Powered by <strong>Trendexplorer</strong>, a product of &copy; <em>TRENDONE GmbH</em>',
    pageTitle: 'PASSWORD FORGOTTEN - REQUEST'
}
